import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Radium } from 'higher-order-components'

/* Render an embeded youtube player */
export class YoutubePlayer extends Component {
  togglePlay = (toggle) => {
    this.videoWindow &&
      this.videoWindow.postMessage(
        `{"event": "command", "func": "${toggle ? 'playVideo' : 'pauseVideo'}", "args": ""}`,
        '*'
      )
  }
  render() {
    return (
      <div style={styles.base}>
        <iframe
          style={styles.video}
          ref={(c) => {
            this.videoWindow = c && c.contentWindow
          }}
          src={`https://www.youtube.com/embed/${this.props.videoId}?autoplay=${this.props.autoPlay
            ? 1
            : 0}&rel=0`}
          allowFullScreen />
      </div>
    )
  }
}

export default Radium(YoutubePlayer)

YoutubePlayer.propTypes = {
  videoId: PropTypes.string,
  autoPlay: PropTypes.bool
}

const styles = {
  base: {
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%',
    overflow: 'hidden'
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    border: 0,
    width: '100%',
    height: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/containers/youtube-player/index.jsx